import React, { useContext } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { Loader } from '@thd-olt-component-react/core-ui';
import proptypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { dataModel } from './dataModel';
import { OverviewRating } from './ratings/OverviewRating';
import { Review } from './reviews/Review';
import { validateResponse } from './validation';

const { string, bool } = proptypes;

export const RatingsAndReview = ({ serviceIdentifier, isDrawerOpen }) => {

  const { localStoreZip } = useContext(ExperienceContext);

  // Initial Tech Shed call to get the first page response and aggergation
  const { data, loading, error } = useDataModel('techShedReviews', {
    variables: {
      serviceIdentifier,
      size: 5,
      from: 0,
      zipcode: localStoreZip,
      sort: 'location_proximity,+created_time+desc'
    },
    ssr: false,
    skip: !isDrawerOpen
  });

  if (loading) {
    // Show loader when gql is in progress
    return (
      <div className="sui-flex sui-justify-center sui-items-center sui-h-5/6">
        <Loader active />
      </div>
    );
  }

  // Validate the response to show error message
  if (validateResponse(data, error, serviceIdentifier)) {
    return (
      <span className="sui-flex sui-justify-center sui-items-center sui-w-full sui-h-5/6" data-testid="reviews-error">
        <h1 className="sui-text-5xl">Review Data Not Available</h1>
      </span>
    );
  }

  const reviewData = data?.techShedReviews || {};

  return (
    <>
      <OverviewRating reviewData={reviewData} />
      <Review serviceIdentifier={serviceIdentifier} isDrawerOpen={isDrawerOpen} />
    </>
  );
};

RatingsAndReview.displayName = 'RatingsAndReview';

RatingsAndReview.dataModel = dataModel;

RatingsAndReview.propTypes = {
  serviceIdentifier: string.isRequired,
  isDrawerOpen: bool
};

RatingsAndReview.defaultProps = {
  isDrawerOpen: false
};
